import { render, staticRenderFns } from "./PreparadorAprobador.vue?vue&type=template&id=3fe5b998&scoped=true&"
import script from "./PreparadorAprobador.vue?vue&type=script&lang=ts&"
export * from "./PreparadorAprobador.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fe5b998",
  null
  
)

export default component.exports